import { render, staticRenderFns } from "./TrainingDashboard.vue?vue&type=template&id=b8f39d36&"
import script from "./TrainingDashboard.vue?vue&type=script&lang=js&"
export * from "./TrainingDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports